import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "../../../config/api.config";
import { Professional, ProfessionalRequest } from "../professional.model";

@Injectable({
  providedIn: "root",
})
export class ProfessionalsService {
  constructor(private http: HttpClient) {}

  findAllByContractType(contractType: string): Observable<any[]> {
    const params = new HttpParams().set("contractType", contractType);
    return this.http.get<any[]>(`${Config.webApiUrl}/v1/person/contract-type`, { params });
  }

  // create(professional: ProfessionalRequest, file: File | null): Observable<any> {
  //   const formData = new FormData();
  //   formData.append("data", JSON.stringify(professional));
  //   if (file) {
  //     formData.append("file", file);
  //   }
  //   return this.http.post(`${Config.webApiUrl}/v1/person`, formData);
  // }
  create(professional: ProfessionalRequest, file: File | null): Observable<any> {
    const formData = new FormData();
    formData.append("data", new Blob([JSON.stringify(professional)], { type: "application/json" }));
    formData.append("file", file);
    return this.http.post(`${Config.webApiUrl}/v1/person`, formData);
  }

  update(id: string, professional: ProfessionalRequest, file?: File): Observable<any> {
    const formData = new FormData();
    formData.append("data", JSON.stringify(professional));

    if (file) {
      formData.append("file", file);
    }

    return this.http.put(`${Config.webApiUrl}/v1/person/${id}`, formData);
  }

  delete(id: string): Observable<Professional> {
    return this.http.delete<Professional>(`${Config.webApiUrl}/v1/person/${id}`);
  }
}
